<!-- 大宗商化工直发数据报告 -->
<template>
  <h-list-page class="bulk-report-container">
    <h-card title="筛选条件" width="100%" is-search @change-method="changeMethod" footer>
      <h-area title-width="90px">
        <h-search title="单号">
          <h-input v-model.trim="searchData.contractNumber" clearable></h-input>
        </h-search>
        <h-search title="物料号">
          <h-input v-model.trim="searchData.mtlNo" clearable></h-input>
        </h-search>
        <h-search title="状态">
          <h-select v-model="searchData.submitStatus" placeholder="请选择" filterable clearable>
            <h-option v-for="item in submitStatusList" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <template #operate>
          <div class="flex-end">
            <h-button type="primary" :loading="tableLoading" @click="handleSearch">
              <template #icon><search /></template>查询
            </h-button>
          </div>
        </template>
      </h-area>
    </h-card>
    <h-table-card title="大宗商钢板报告数据">
      <!-- <template #buttonGroup>
        <h-button-group>
          <div style="margin-left: 10px;">
             <h-button type="primary" @click="handleVersion">
            切换旧版 
            </h-button>
            <span style="font-size: 12px;color: red;position: relative;top: 5px;">
              备注：大宗商报告新版试运行，老版本预计10月30号下线；新版使用过程中若有问题请及时反馈，紧急业务可优先切换旧版处理。
            </span> 
          </div> 
        </h-button-group>
      </template> -->
      <el-table empty-text="暂无数据" v-loading="tableLoading" border :data="tableData"
        size="small" style="width: 100%; min-height: 520px" height="540">
        <el-table-column prop="contractNumber" label="单号" width="160"></el-table-column>
        <el-table-column prop="coilNumber" label="捆包号" width="120"></el-table-column>
        <el-table-column prop="storageTime" label="入库时间" width="100"></el-table-column>
        <el-table-column prop="parkName" label="园区"></el-table-column>
        <el-table-column prop="bulkSupplyCode" label="大宗商编码"></el-table-column>
        <el-table-column prop="bulkSupplyName" label="大宗商名称" width="220"></el-table-column>
        <el-table-column prop="mtlNo" label="物料号" width="140"></el-table-column>
        <el-table-column prop="mtlName" label="物料名称" width="220"></el-table-column>
        <el-table-column prop="mtlCategoryName" label="物料类别"></el-table-column>
        <el-table-column prop="amount" label="数量"></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column prop="checkReportName" label="检验报告名称" width="180">
          <template v-slot="scope">
            <span title="附件下载" class="blue-text"
            @click="downLoadFileFromSQM(scope.row.bulkSupplyCode,scope.row.checkReportUUID,scope.row.checkReportName,scope.row.isSynchro)">{{ scope.row.checkReportName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template v-slot="scope">
            <span v-if="roleFlag=='S'">
              <span v-if="scope.row.submitStatus=='N'">
                <!-- <h-button type="warning" @click="handleReport(scope.row)">
                  <upload-picture theme="outline" />
                  上传报告
                </h-button> -->
                <span class="blue-text" @click="handleReport(scope.row)">上传报告</span>
              </span>
              <span v-if="scope.row.submitStatus=='Y'">已上传</span>
              <span v-else></span>
            </span>
            <span v-else>
              <span v-if="scope.row.submitStatus=='N'">待上传</span>
              <span v-else-if="scope.row.submitStatus=='Y'">已上传</span>
              <span v-else></span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @current-change="handlePageChange"
        v-model:currentPage="currentPage" :page-size="10"
        layout="total, prev, pager, next,jumper" :total="total">
      </el-pagination>
    </h-table-card>
  </h-list-page>
</template>

<script>
import { submitStatusList } from './index.js'
export default {
  data(){
    return{
      searchData:{},
      tableLoading: false,
      tableData:[],
      pageNo:1,
      total:0,
      submitStatusList,
      roleFlag:''
    }
  },
  watch: {
    $route: {
      handler: (val, oldVal) => {
        let vcode =''
        let roleCode = val&&val.query&&val.query.roleCode?val.query.roleCode:''
        if(roleCode.indexOf("H")==0){//如果是海尔端
          vcode = val.query.vCode || val.query.supplyCode
          if(vcode!=""){
            this.roleFlag="SN";
          }
        }else{//如果是供应商端。控制只显示本供应商下的样检单
          vcode = val&&val.query&&val.query.supplyCode?val.query.supplyCode:''
          if(roleCode=="S009"){//只有质量经理才能操作
            this.roleFlag="S";
          }else{
            this.roleFlag="SN";
          }
        }
        console.log('this.roleFlag=====',this.roleFlag)
      },
      immediate: true,
    },
  },
  methods:{
    changeMethod() {
      this.postThisPageHeight();
    },
    handleSearch(){
      this.pageNo = 1
      this.getTableData()
    },
    // 获取页面数据
    getTableData(){
      this.tableLoading = true
      this.$http({
        method: "post",
        url: "/base/inspectionReport/selectPage",
        headers: { "content-type": "application/json" },
        data: {
          pageNo: this.pageNo,
          pageSize: 10,
          dataFlag:'HZ',// G:钢板 HZ：化工直发 HFZ：化工非直发
          bulkSupplyCode: this.$route.query.supplyCode,
          ...this.searchData
        },
      }).then((res) => {
        console.log('ressss',res)
        if(res.data.code==0){
          this.tableData = res.data.data.records || []
          this.total = res.data.data.total
          console.log('this.total',this.total)
        }
        this.tableLoading = false
      }).catch(err => {
        console.log(err)
      })  
    },
    handlePageChange(val){
      this.pageNo = val
      this.getTableData()
    },
    downLoadFileFromSQM(bulkSupplyCode,uuid,fileName,isSynchro){
      if(uuid == ""||uuid == undefined ||uuid == null){
        this.info("没有可下载的文件！");
        return false;
      }
      let suffix = uuid.includes("mkhl/") || uuid.includes("/testonline/");
  
      //同步的报告按供应商分类查看报告
      if(isSynchro == "Y"){
        if(bulkSupplyCode=="V12973"){
            window.open("https://sqm.haier.net/readFile/testonline/baogang/"+fileName+".pdf","_blank");
        }else{
          if (suffix) {
            let url = uuid.includes("file/mkhl/testonline/") ? "/base/fileDownload/downloadFile?filePath=" + uuid.split('/file/mkhl')[1] : uuid.includes("testonline/baogang") ? "/base/fileDownload/downloadFile?filePath=" + uuid : "/base/fileDownload/downloadFile?filePath=" + uuid;;
            let extension = uuid.substring(uuid.lastIndexOf('.') );
            let downLoadFileName = uuid.includes("file/mkhl/testonline/")||uuid.includes("testonline/baogang") ? `${fileName}${extension}` : fileName
            this.httpFile(
              {
                method: "get",
                url: url,
                headers: { "content-type": "application/json" },
              },
              downLoadFileName
            );
          } else{
            let url = `/base/fileDownload/downLoadFileFtp?type=10&fileUUID=${uuid}`;
            this.httpFile(
              {
                method: "get",
                url: url,
                headers: { "content-type": "application/json" },
              },
              fileName
            );
          }
        }
      }else{
        if (suffix) {
          let url = uuid.includes("file/mkhl/testonline/") ? "/base/fileDownload/downloadFile?filePath=" + uuid.split('/file/mkhl')[1] : uuid.includes("testonline/baogang") ? "/base/fileDownload/downloadFile?filePath=" + uuid : "/base/fileDownload/downloadFile?filePath=" + uuid;;
          let extension = uuid.substring(uuid.lastIndexOf('.') );
          let downLoadFileName = uuid.includes("file/mkhl/testonline/")||uuid.includes("testonline/baogang") ? `${fileName}${extension}` : fileName
          this.httpFile(
            {
              method: "get",
              url: url,
              headers: { "content-type": "application/json" },
            },
            downLoadFileName
          );
        } else{
          let url = `/base/fileDownload/downLoadFileFtp?type=9&fileUUID=${uuid}`;
          this.httpFile(
            {
              method: "get",
              url: url,
              headers: { "content-type": "application/json" },
            },
            fileName
          );
        }
      }
    },
    handleReport(row){
      const params = {}
      params.name  = this.$route.query.name || this.$route.query.name
      params.nickName  = this.$route.query.nickName || this.$route.query.name
      params.dataFrom  = this.$route.query.dataFrom
      params.group  = this.$route.query.group
      // params.vCode = this.$route.query.vCode
      params.supplyCode = this.$route.query.supplyCode||this.$route.query.vCode,
      params.routeName = this.$route.name
      params.contractNumber = row.contractNumber
      params.coilNumber = row.coilNumber
      params.roleCode = this.$route.query.roleCode
      this.$router.push({name:'uploadReport',query:{id:row.id,...params}})
    },
    handleVersion(){
      const vCode = this.$route.query.supplyCode
      if (process.env.NODE_ENV != 'production') {
        window.open("https://t-api-cn-sp000339-bridge-i.hwork.haier.net/report/bulk_supplier_zf_report_list?supplyCode="+ vCode)
      }else{
        window.open("https://sqm.haier.net/report/bulk_supplier_zf_report_list?supplyCode="+ vCode)
      }
    }
  },
  mounted(){
    let vcode =''
    let roleCode = this.$route&&this.$route.query&&this.$route.query.roleCode?this.$route.query.roleCode:''
    if(roleCode.indexOf("H")==0){//如果是海尔端
      vcode = this.$route.query.vCode || this.$route.query.supplyCode
      if(vcode!=""){
          this.roleFlag="SN";
      }
    }else{//如果是供应商端。控制只显示本供应商下的样检单
      vcode = this.$route&&this.$route.query&&this.$route.query.supplyCode?this.$route.query.supplyCode:''
      if(roleCode=="S009"){//只有质量经理才能操作
        this.roleFlag="S";
      }else{
        this.roleFlag="SN";
      }
    }
    if (this.$route.query) {
      this.searchData.name = this.$route.query.name;  
      this.searchData.nickName = this.$route.query.nickName || this.$route.query.name;
      window.getItemName = this.$route.query.name;
      window.getItemNickName = this.$route.query.nickName || this.$route.query.name;
    }
    this.getTableData()
  }
}
</script>
<style scoped>
.blue-text{
  color: #165dff;
  cursor: pointer;
}
</style>